import { Component, inject } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { IsAdminDirective } from '@app/directives/is-admin.directive';
import { HeaderAdminComponent } from './admin/header-admin/header-admin.component';
import { HeaderComponent } from './community/header/header.component';
import { UserStore } from './store/user.store';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    HeaderComponent,
    HeaderAdminComponent,
    IsAdminDirective,
  ],
  providers: [UserStore],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  title = 'portal-ui';
  userStore = inject(UserStore);
}
